import 'scss/solutions/virtual-receptionist.scss'
import 'babel-polyfill'
import 'js/libs/utils-solutions'

var video1 = document.getElementById('video-intro')
var video2 = document.getElementById('video-case')

$(function () {
  video1.addEventListener('play', function () {
    video2.pause()
  })
  video2.addEventListener('play', function () {
    video1.pause()
  })
})



// WEBPACK FOOTER //
// ./src/js/entry/solutions/virtual-receptionist.js